module.exports = __webpack_public_path__ + "static/media/largePlace.8fc0629c.svg";